import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { empty, Observable } from 'rxjs';
import { catchError, map, tap } from 'rxjs/operators';
import { environment } from '../../../environments/environment';
import { Bp1configurationRequest, Bp2ConfigurationRequest, IBp1configurationRequest, IBp2ConfigurationRequest, IProduct, IV6Product, IProductCategory, IProductConfig, IProductTemplate, Product, ProductCategory, ProductTemplate, V6OptionTranslation, BaseResponse, V6OptionValueTranslation } from '../models';
import { ApiService } from './api.service';
import { ConfigService } from './config.service';

@Injectable({
  providedIn: 'root'
})
export class ProductService {

  //#region ProductService constructor
  constructor(private httpClient: HttpClient) { }
  //#endregion
  //#region ProductService Api endPoints
  public getAllProductTemplate(): Observable<Array<IV6Product>> {
    const endPoint = `${ConfigService.APIs.endPoints.PRODUCT.GET_ALL_PRODUCT_TEMPLATE}`;
    return ApiService.genericObservableGet(this.httpClient, endPoint)
      .pipe(
        catchError((err, caught) => { console.log(err); console.log(caught); return empty(); }),
        map((response: BaseResponse) => response.data),
        tap((productTemplates) => { console.log(productTemplates); })
      );
  }
  public createProductTemplate(body: IV6Product): Observable<IV6Product> {
    const endPoint = `${ConfigService.APIs.endPoints.PRODUCT.CREATE_PRODUCT_TEMPLATE}`;
    return ApiService.genericObservablePost(this.httpClient, endPoint, body
    )
      .pipe(
        catchError((err, caught) => { console.log(err); console.log(caught); return empty(); }),
        map((response: BaseResponse) => { let result: any; result = response.data; return result; } ),
        tap((productTemplate) => { console.log(productTemplate); })
      );
  }
  public updateProductTemplate(body: IV6Product): Observable<IV6Product> {
    const endPoint = `${ConfigService.APIs.endPoints.PRODUCT.EDIT_PRODUCT_TEMPLATE}`;
    return ApiService.genericObservablePost(this.httpClient, endPoint, body
    )
      .pipe(
        catchError((err, caught) => { console.log(err); console.log(caught); return empty(); }),
        map((response: BaseResponse) => { let result: any; result = response.data; return result; } ),
        tap((productTemplate) => { console.log(productTemplate); })
      );
  }


  public deleteProductTemplate(body: IV6Product): Observable<any> {
    const endPoint = `${ConfigService.APIs.endPoints.PRODUCT.DELETE_PRODUCT_TEMPLATE}`;
    return ApiService.genericObservablePost(this.httpClient, endPoint, body)
      .pipe(
        catchError((err, caught) => { console.log(err); console.log(caught); return empty(); }),
        map((response: BaseResponse) => { let result: any; result = response.data; return result; }),
        tap((productTemplate) => { console.log(productTemplate); })
      )
  }

  public getAllCategories(languageCode): Observable<Array<IProductCategory>> {
    const endPoint = `${ConfigService.APIs.endPoints.PRODUCT.GET_ALL_CATEGORIES}/${languageCode}`;
    return ApiService.genericObservableGet(this.httpClient, endPoint)
      .pipe(
        catchError((err, caught) => { console.log(err); console.log(caught); return empty(); }),
        map((response: BaseResponse) => this.changeImageUrlForProductCategories(response.data)),
        tap((productCategories) => { this.productCategories = productCategories })
      );
  }
  public getProductsByCategoryId(body): Observable<Array<IProduct>> {
    const endPoint = `${ConfigService.APIs.endPoints.PRODUCT.GET_PRODUCTS_BY_CATEGORYID}/${body.productCategoryId}/${body.languageCode}/${body.customerNumber}`;
    return ApiService.genericObservableGet(this.httpClient, endPoint)
      .pipe(
        catchError((err, caught) => { console.log(err); console.log(caught); return empty(); }),
        map((response: BaseResponse) => this.changeImageUrlForProducts(response.data)),
        tap((products) => { this.products = products })
      );
  }
  public createConfiguration(body: any): Observable<any> {
    const endPoint = `${ConfigService.APIs.endPoints.PRODUCT.CREATE_CONFIGURATION}`;
    return ApiService.genericObservableGet(this.httpClient, endPoint).pipe(
      catchError((err, caught) => { console.log(err); console.log(caught); return empty(); }),
      map((response: BaseResponse) => response.data),
      tap((configuration) => { console.log(configuration); })
    );
  }
  public getConfiguration(quoteItemCommonId: string): Observable<any> {
    const endPoint = `${ConfigService.APIs.endPoints.PRODUCT.GET_CONFIGURATION}/${quoteItemCommonId}`;
    return ApiService.genericObservableGet(this.httpClient, endPoint).pipe(
      catchError((err, caught) => { console.log(err); console.log(caught); return empty(); }),
      map((response: BaseResponse) => response.data),
      tap((configuration) => { console.log(configuration); })
    );
  }
  public copyConfiguration(quoteItemCommonId: string): Observable<any> {
    const endPoint = `${ConfigService.APIs.endPoints.PRODUCT.COPY_CONFIGURATION}/${quoteItemCommonId}`;
    return ApiService.genericObservableGet(this.httpClient, endPoint).pipe(
      catchError((err, caught) => { console.log(err); console.log(caught); return empty(); }),
      map((response: BaseResponse) => response.data),
      tap((configuration) => { console.log(configuration); })
    );

  }
  //public createConfigurationServiceX(body: any): Observable<any> {
  //public createConfiguration(): Observable<any> {
  //  const endPoint = `${ConfigService.APIs.endPoints.PRODUCT.CREATE_CONFIGURATION}`;
  //  return ApiService.genericObservableGet(this.httpClient, endPoint);
  //}
  public createConfigurationX(body: any): Observable<any> {
    const endPoint = `${ConfigService.APIs.endPoints.PRODUCT.CREATE_CONFIGURATION}`;
    return ApiService.genericObservablePost(this.httpClient, endPoint, body).pipe(
      catchError((err, caught) => { console.log(err); console.log(caught); return empty(); }),
      map((response: BaseResponse) => response.data),
      tap((configuration) => {
        console.log('create config response');
        console.log(configuration);
      })
    );
  }
  public updateOnlyConfiguration(body: any): Observable<any> {
    const endPoint = `${ConfigService.APIs.endPoints.PRODUCT.UPDATE_ONLY_CONFIGURATION}`;
    return ApiService.genericObservablePost(this.httpClient, endPoint, body).pipe(
      catchError((err, caught) => { console.log(err); console.log(caught); return empty(); }),
      map((response: BaseResponse) => response.data),
      tap((configuration) => { console.log(configuration); })
    );
  }
  public updateConfiguration(body: any): Observable<any> {
    const endPoint = `${ConfigService.APIs.endPoints.PRODUCT.UPDATE_CONFIGURATION}`;
    return ApiService.genericObservablePost(this.httpClient, endPoint, body).pipe(
      catchError((err, caught) => { console.log(err); console.log(caught); return empty(); }),
      map((response: BaseResponse) => response.data),  
      tap((configuration) => {
        console.log('update config response');
        console.log(configuration);
      })
    );
  }

  public getThumbnailImage(data: any): Observable<any> {
    const endPoint = `${ConfigService.APIs.endPoints.PRODUCT.GET_PRODUCT_CONFIG_IMG}`;
    return ApiService.genericObservablePost(this.httpClient, endPoint, data);

    //return ApiService.genericObservablePost(this.httpClient, endPoint, data).pipe(
    //  catchError((err, caught) => { console.log(err); console.log(caught); return empty(); }),
    //  map((response: BaseResponse) => response.data)
    //);
    //;//.pipe(
    //  tap((configuration) => { console.log(configuration); })
    //);
  }
  //#endregion

  selectedProductTemplate: IV6Product = null;
  //#region ProductService Cache
  private PRODUCT_CATEGORIES: ProductCategory[] = [];
  public get productCategories(): ProductCategory[] {
    if (!this.PRODUCT_CATEGORIES) {
      this.PRODUCT_CATEGORIES = [];
    }
    return this.PRODUCT_CATEGORIES;
  }
  public set productCategories(productCategories: ProductCategory[]) {
    if (productCategories) {
      this.PRODUCT_CATEGORIES = productCategories;
    } else {
      this.PRODUCT_CATEGORIES = [];
    }
  }

  private PRODUCTS: Product[] = [];
  public get products(): Product[] {
    if (!this.PRODUCTS) {
      this.PRODUCTS = [];
    }
    return this.PRODUCTS;
  }
  public set products(products: Product[]) {
    if (products) {
      this.PRODUCTS = products;
    } else {
      this.PRODUCTS = [];
    }
  }

  private imageUrl: string = `${environment.imageUrl}/ResourceCenter/Content/ProductImages/Build and Buy/PROD-2000T.jpg`;
  private productImageUrl: string = `${environment.imageUrl}/ResourceCenter/Content/ProductImages/Build and Buy/PROD-2000T.jpg`;
  //#endregion
  //#region ProductService BusinessLogic
  private changeImageUrlForProductCategories(productCategories: ProductCategory[]) {
    if (productCategories) {
      if (this.imageUrl) {
        productCategories.forEach((item, index) => {
          const tempImageUrl = item.imageUrl;
          item.imageUrl = `${environment.imageUrl}/ResourceCenter/Content/ProductImages/${tempImageUrl}`
        })
      }
    }
    return productCategories;
  }
  private changeImageUrlForProducts(products: Product[]) {
    if (products) {
      if (this.imageUrl) {
        products.forEach((item, index) => {
          const tempImageUrl = item.productImageUrl;
          item.productImageUrl = `${environment.imageUrl}/ResourceCenter/Content/ProductImages/${tempImageUrl}`
        })
      }
    }
    return products;
  }
  //#endregion

  //#region Product config/details
  public getProductDetailsByProductId(body) {    
    const endPoint = `${ConfigService.APIs.endPoints.PRODUCT.GET_PRODUCT_CONFIG_FORPRODUCT}`;
    return ApiService.genericObservablePost(this.httpClient, endPoint, body).pipe(
      catchError((err, caught) => { console.log(err); console.log(caught); return empty(); }),
      map((productConfigurations: BaseResponse) => this.changeImageUrlForProductConfig(productConfigurations.data)),
      tap((productConfigurations) => { console.log(productConfigurations); })
    );
  }

  private changeImageUrlForProductConfig(products: IProductConfig[]) {
    if (products) {
      if (this.imageUrl) {
        products.forEach((item, index) => {
          const tempImageUrl = item.imageUrl;
          item.imageUrl = `${environment.imageUrl}/ResourceCenter/Content/ProductImages/${tempImageUrl}`
        })
      }
    }
    return products;
  }
  //#endrefgion

  //#region manage translation

  editTranslation: V6OptionTranslation;
  editValueTranslation: V6OptionValueTranslation;

  public GetOptionTranslation(): Observable<any> {
    const endPoint = `${ConfigService.APIs.endPoints.PRODUCT.GET_OptionTranslation}`;
    return ApiService.genericObservableGet(this.httpClient, endPoint)
      .pipe(
        catchError((err, caught) => { console.log(err); console.log(caught); return empty(); }),
        map((response: BaseResponse) => response.data)
      );;
  }
  public GetProductCode(): Observable<any> {
    const endPoint = `${ConfigService.APIs.endPoints.PRODUCT.GET_ProductCode}`;
    return ApiService.genericObservableGet(this.httpClient, endPoint).pipe(
      catchError((err, caught) => { console.log(err); console.log(caught); return empty(); }),
      map((response: BaseResponse) => response.data)
    );
  }
  public AddTranslation(body: any): Observable<any> {
    const endPoint = `${ConfigService.APIs.endPoints.PRODUCT.CREATE_OptionTranslation}`;
    return ApiService.genericObservablePost(this.httpClient, endPoint, body).pipe(
      catchError((err, caught) => { console.log(err); console.log(caught); return empty(); }),
      map((response: BaseResponse) => response.data)
    );
  }
  public EditTranslation(body: any): Observable<any> {
    const endPoint = `${ConfigService.APIs.endPoints.PRODUCT.EDIT_OptionTranslation}`;
    return ApiService.genericObservablePost(this.httpClient, endPoint, body).pipe(
      catchError((err, caught) => { console.log(err); console.log(caught); return empty(); }),
      map((response: BaseResponse) => response.data)
    );
  }
  public GetOptionValueTranslation(): Observable<any> {
    const endPoint = `${ConfigService.APIs.endPoints.PRODUCT.GET_OptionValueTranslation}`;
    return ApiService.genericObservableGet(this.httpClient, endPoint).pipe(
      catchError((err, caught) => { console.log(err); console.log(caught); return empty(); }),
      map((response: BaseResponse) => response.data)
    );
    //.pipe(
    //  catchError((err, caught) => { console.log(err); console.log(caught); return empty(); }),
    //  map((response: BaseResponse) => response.data)
    //);;
  }
  public AddValueTranslation(body: any): Observable<any> {
    const endPoint = `${ConfigService.APIs.endPoints.PRODUCT.CREATE_OptionValueTranslation}`;
    return ApiService.genericObservablePost(this.httpClient, endPoint, body).pipe(
      catchError((err, caught) => { console.log(err); console.log(caught); return empty(); }),
      map((response: BaseResponse) => response.data)
    );
  }

  //#endregion
  public deleteOptionTranslator(body: any): Observable<any> {
    const apiEndpoint = `${ConfigService.APIs.endPoints.PRODUCT.DELETE_OPTION_TRANSLATOR}`;
    return ApiService.genericObservablePost(this.httpClient, apiEndpoint, body)
  }
  public deleteOptionValueTranslator(body: any): Observable<any> {
    const apiEndpoint = `${ConfigService.APIs.endPoints.PRODUCT.DELETE_OPTION_VALUE_TRANSLATOR}`;
    return ApiService.genericObservablePost(this.httpClient, apiEndpoint, body)
  }
  public deleteProductCategory(body: any): Observable<any> {
    const apiEndpoint = `${ConfigService.APIs.endPoints.PRODUCT.DELETE_PRODUCT_CATEGORY}`;
    return ApiService.genericObservablePost(this.httpClient, apiEndpoint, body)
  }
  public deleteProductSubCategory(body: any): Observable<any> {
    const apiEndpoint = `${ConfigService.APIs.endPoints.PRODUCT.DELETE_PRODUCT_SUB_CATEGORY}`;
    return ApiService.genericObservablePost(this.httpClient, apiEndpoint, body)
  }
  public deleteProductConfiguration(body: any): Observable<any> {
    const apiEndpoint = `${ConfigService.APIs.endPoints.PRODUCT.DELETE_PRODUCT_CONFIGURATION}`;
    return ApiService.genericObservablePost(this.httpClient, apiEndpoint, body)
  }
  //#region configure New Product

  bp1configuration: IBp1configurationRequest = new Bp1configurationRequest();
  bp2configuration: IBp2ConfigurationRequest = new Bp2ConfigurationRequest();
  configureProduct: IProductTemplate = new ProductTemplate();

} //#endregion
